<template>
  <el-container style="height: 100%">
    <el-main style="height: 100%;margin: 0px;padding: 0px">
      <el-table :data="tableData" stripe style="width: 100%" border size="mini">
        <el-table-column
          type="index" label="排名">
        </el-table-column>
        <!--<el-table-column prop="storename" align="center" label="门店" width="100"></el-table-column>-->
        <el-table-column prop="staffname" align="center" label="姓名" width="60">
          <template slot-scope="scope">
            <div>{{scope.row.storename}}</div>
            <div>{{scope.row.staffname}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="perf" align="center" label="业绩" width="70">
          <template slot-scope="scope">
            <div>{{scope.row.perf}}</div>
            <div v-if="scope.row.number>=2"><span style="color: red">{{scope.row.number+1}}天没业绩</span></div>
          </template>
        </el-table-column>
        <el-table-column prop="newnumber" align="center" label="新客" width="60"></el-table-column>
        <el-table-column prop="bigdd" align="center" label="门店客量" width="100"></el-table-column>
        <el-table-column prop="bigcount" align="center" label="个人客量" width="100"></el-table-column>
        <el-table-column  align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" v-if="staffid==scope.row.staffid && scope.row.log==false" @click="openReadLog(scope)">待读</el-button>
            <span v-if="scope.row.log">已读</span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog title="阅读" :visible.sync="dialogTableVisible" width="100%">
      <el-form @submit.native.prevent :model="addReadLog">
        <el-form-item label="业绩">
          <el-input placeholder="请输入业绩" v-model="addReadLog.perf" type="number" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogTableVisible=false">取消</el-button>
        <el-button type="primary" size="mini" @click="saveReadLog()">保存</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      addReadLog:{},
      readlog:{
        storeid:"",
        staffid:"",
        perf:0,
        accountdate:"",
      },
      dialogTableVisible:false,
      tableData:[],
      staffid:"714fc9336c7d40688877d370599f500d",
      curRow:{},
      curIndex:0,
    }
  },
  created() {
      this.getBeautyManagerExamineVo();
  },
  methods:{
    openReadLog(scope){
      this.dialogTableVisible=true;
      this.addReadLog=this.$copy(this.readlog);
      this.curRow=scope.row;
      this.curIndex=scope.$index;
    },
    saveReadLog(){
      if(this.addReadLog.perf!=this.curRow.perf){
        this.$message.error("请填写正确的业绩");
        return;
      }
      let obj=new Object();
      obj.storeid=this.curRow.storeid;
      obj.staffid=this.curRow.staffid;
      obj.perf=this.addReadLog.perf;
      this.$postw("remind/saveReadLog",obj).then(res=>{
        if(res.sucess){
          this.$message({
            message: '保存成功',
            type: 'success'
          });
          this.tableData[this.curIndex].log=true;
          this.dialogTableVisible=false;
        }
        else{
          this.$message.error(res.message);
        }
      });
    },
    getCorpUserInfo(staffid) {
      this.$post("wechat/getCorpUserInfo", {staffid: staffid}).then(res => {
        if (res.sucess) {
          let data = res.object;
          if (data.staff == null || data.staff == undefined) {
            this.$message.error('没有找到您的信息');
          } else {
            this.staff = data.staff;
            this.staffid=data.staff.staffid;
            localStorage.setItem("token", data.token);
            localStorage.setItem("staffid", data.staff.staffid);
            localStorage.setItem("deptid", data.staff.deptid);
            localStorage.setItem("staffname", data.staff.staffname);
            localStorage.setItem("posid", data.staff.posid);
            localStorage.setItem("storename", data.staff.storename);
            localStorage.setItem("storeid", data.staff.storeid);
            localStorage.setItem("parentstoreid", data.staff.storeid);
            this.getBeautyManagerExamineVo();
          }
        } else {
          window.close();
        }
      });
    },
    getBeautyManagerExamineVo(){
      this.$post("remind/getBeautyManagerExamineVo").then(res=>{
        if(res.sucess){
          this.tableData=res.object;
        }
        else{
          this.$message.error(res.message);
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/beauty/beautymanagerrank.vue